"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Logger = exports.LogLevel = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LogLevel = exports.LogLevel = /*#__PURE__*/function (LogLevel) {
  LogLevel[LogLevel["Trace"] = 1] = "Trace";
  LogLevel[LogLevel["Debug"] = 2] = "Debug";
  LogLevel[LogLevel["Info"] = 3] = "Info";
  LogLevel[LogLevel["Warn"] = 4] = "Warn";
  LogLevel[LogLevel["Error"] = 5] = "Error";
  LogLevel[LogLevel["Critical"] = 6] = "Critical";
  return LogLevel;
}({});
var Logger = exports.Logger = /*#__PURE__*/_createClass(function Logger() {
  var _this = this;
  _classCallCheck(this, Logger);
  _defineProperty(this, "enabled", true);
  _defineProperty(this, "logLevel", LogLevel.Error);
  _defineProperty(this, "_pfix", "[DRG]");
  _defineProperty(this, "trace", function (m) {
    if (_this.enabled && _this.logLevel <= 1) console.log(_this._pfix + " TRACE | " + m);
  });
  _defineProperty(this, "debug", function (m) {
    if (_this.enabled && _this.logLevel <= 2) console.log(_this._pfix + " DEBUG | " + m);
  });
  _defineProperty(this, "dir", function (txt, m) {
    if (_this.enabled && _this.logLevel <= 2) {
      console.log(_this._pfix + " DEBUG | " + txt);
      console.dir(m);
    }
    ;
  });
  _defineProperty(this, "info", function (m) {
    if (_this.enabled && _this.logLevel <= 3) console.log(_this._pfix + " INFO | " + m);
  });
  _defineProperty(this, "warn", function (m) {
    if (_this.enabled && _this.logLevel <= 4) console.warn(_this._pfix + " WARN | " + m);
  });
  _defineProperty(this, "error", function (m) {
    if (_this.enabled && _this.logLevel <= 5) console.error(_this._pfix + " ERROR | " + m);
  });
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    this.logLevel = LogLevel.Trace;
  }
});
var L = new Logger();
var _default = exports["default"] = L;
//# sourceMappingURL=logger.js.map